"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function allFields(state) {
    return {
        address: state.address,
        city: state.city,
        postalCountryCode: state.postalCountryCode,
        countryCode: state.countryCode,
        email: state.email,
        prefix: state.prefix,
        phone: state.phone,
        zipCode: state.zipCode,
    };
}
exports.allFields = allFields;
function allFieldsArray(state) {
    return [
        state.address,
        state.city,
        state.postalCountryCode,
        state.countryCode,
        state.email,
        state.prefix,
        state.phone,
        state.zipCode,
    ];
}
exports.allFieldsArray = allFieldsArray;
function address(state) {
    return state.address;
}
exports.address = address;
function city(state) {
    return state.city;
}
exports.city = city;
function postalCountryCode(state) {
    return state.postalCountryCode;
}
exports.postalCountryCode = postalCountryCode;
function countryCode(state) {
    return state.countryCode;
}
exports.countryCode = countryCode;
function email(state) {
    return state.email;
}
exports.email = email;
function prefix(state) {
    return state.prefix;
}
exports.prefix = prefix;
function phone(state) {
    return state.phone;
}
exports.phone = phone;
function zipCode(state) {
    return state.zipCode;
}
exports.zipCode = zipCode;
function validations(state) {
    return state.formValidations;
}
exports.validations = validations;
function paymentCountries(state) {
    return state.paymentCountries;
}
exports.paymentCountries = paymentCountries;
function valid(state) {
    return state.allFieldsValid;
}
exports.valid = valid;
function primaryPaxId(state) {
    return state.primaryPaxId;
}
exports.primaryPaxId = primaryPaxId;
function terms(state) {
    return state.tradingConditionsAccepted;
}
exports.terms = terms;
function termsHasError(state) {
    return state.tradingConditionsAcceptedHasError;
}
exports.termsHasError = termsHasError;
function covidNote(state) {
    return state.covidNoteAccepted;
}
exports.covidNote = covidNote;
function covidNoteHasError(state) {
    return state.covidNoteAcceptedHasError;
}
exports.covidNoteHasError = covidNoteHasError;
function formSheetPauschal(state) {
    return state.formSheetPauschal;
}
exports.formSheetPauschal = formSheetPauschal;
function formSheetPauschalHasError(state) {
    return state.formSheetPauschalHasError;
}
exports.formSheetPauschalHasError = formSheetPauschalHasError;
function insuranceBooked(state) {
    return state.insuranceBooked;
}
exports.insuranceBooked = insuranceBooked;
function ippBooked(state) {
    return state.ippBooked;
}
exports.ippBooked = ippBooked;
function ippAccepted(state) {
    return state.ippField.value;
}
exports.ippAccepted = ippAccepted;
function ippAcceptedError(state) {
    return state.ippField.error;
}
exports.ippAcceptedError = ippAcceptedError;
function ippField(state) {
    return state.ippField;
}
exports.ippField = ippField;
function termsInsurance(state) {
    return state.insuranceConditionsAccepted;
}
exports.termsInsurance = termsInsurance;
function termsInsuranceHasError(state) {
    return state.insuranceConditionsAcceptedHasError;
}
exports.termsInsuranceHasError = termsInsuranceHasError;
function price(state) {
    return state.price;
}
exports.price = price;
function formPDF(state) {
    return state.formPDF;
}
exports.formPDF = formPDF;
// export everything compliant to the vuex specification for getters
exports.default = {
    address: address,
    city: city,
    postalCountryCode: postalCountryCode,
    countryCode: countryCode,
    email: email,
    prefix: prefix,
    phone: phone,
    zipCode: zipCode,
    validations: validations,
    valid: valid,
    paymentCountries: paymentCountries,
    primaryPaxId: primaryPaxId,
    allFields: allFields,
    terms: terms,
    termsHasError: termsHasError,
    covidNote: covidNote,
    covidNoteHasError: covidNoteHasError,
    termsInsurance: termsInsurance,
    termsInsuranceHasError: termsInsuranceHasError,
    formSheetPauschal: formSheetPauschal,
    formSheetPauschalHasError: formSheetPauschalHasError,
    price: price,
    insuranceBooked: insuranceBooked,
    allFieldsArray: allFieldsArray,
    ippBooked: ippBooked,
    ippAccepted: ippAccepted,
    ippAcceptedError: ippAcceptedError,
    ippField: ippField,
    formPDF: formPDF,
};
//# sourceMappingURL=getters.js.map